/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { CommonDropdown, RegularButton, CommonInput, ICommonDropdownOption, Loader } from 'pg-ui-library';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import InvoiceService from 'src/services/invoice.service';
import { useQuery } from '@tanstack/react-query';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Chip } from '@mui/material';
import { CellSpan, Container, ScreenHeader, RightHeader, PageTitle, EmptyContainer } from './styles';
import { InvoiceStatus } from '../enums/invoice-status';
import { useTranslation } from 'react-i18next';
import { NewFiltersInvoice } from '../modals/filtersModal';
import { ProcessBillingModal } from '../modals/processBillingModal';
import { DateTime } from 'luxon';
import DownloadInvoiceModal from '../modals/DownloadInvoiceModal';
const myinvocieOptions: ICommonDropdownOption[] = [
  // {
  //   key: '1',
  //   label: InvoiceStatus.ALL.label,
  //   value: InvoiceStatus.ALL.value,
  // },
  {
    key: '2',
    label: InvoiceStatus.DRAFT.label,
    value: InvoiceStatus.DRAFT.value,
  },
  {
    key: '3',
    label: InvoiceStatus.SUBMITTED.label,
    value: InvoiceStatus.SUBMITTED.value,
  },
  {
    key: '4',
    label: InvoiceStatus.APPROVED.label,
    value: InvoiceStatus.APPROVED.value,
  },
  {
    key: '5',
    label: InvoiceStatus.COMPLETED.label,
    value: InvoiceStatus.COMPLETED.value,
  },
  {
    key: '6',
    label: InvoiceStatus.REJECTED.label,
    value: InvoiceStatus.REJECTED.value,
  },
  {
    key: '7',
    label: InvoiceStatus.BILL_PROCESSED.label,
    value: InvoiceStatus.BILL_PROCESSED.value,
  },
  {
    key: '8',
    label: InvoiceStatus.PAY_PROCESSED.label,
    value: InvoiceStatus.PAY_PROCESSED.value,
  },
];

const InvoiceListBillProcess: React.FC = () => {
  const navigate = useNavigate();
  const validationSchema = yup.object({
    subject: yup.string().max(255).required(),
  });

  const billProcessStatusOptions: ICommonDropdownOption[] = [
    { key: 'approved', label: 'Approved', value: 'approved' },
    { key: 'payProcessed', label: 'Pay Processed', value: 'pay_processed' },
  ];

  const formatDateForApi = (date: Date | null) => {
    if (!date) return null;
    return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
  };

  const { t } = useTranslation();
  const statusMapping: Record<
    string,
    { color: 'default' | 'primary' | 'secondary' | 'error' | 'success'; label: string; bgColor: string }
  > = {
    rejected: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },
    Rejected: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },
    Reject: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },

    draft: { color: 'default', label: 'Draft', bgColor: '#546E7A' },
    Draft: { color: 'default', label: 'Draft', bgColor: '#546E7A' },

    submitted: { color: 'default', label: 'Submitted', bgColor: '#0288d1' },
    Submitted: { color: 'default', label: 'Submitted', bgColor: '#0288d1' },

    pay_processed: { color: 'default', label: 'Pay Processed', bgColor: '#00897b' }, // teal
    Pay_processed: { color: 'default', label: 'Pay Processed', bgColor: '#00897b' },

    approved: { color: 'default', label: 'Approved', bgColor: '#F9A825' },
    Approved: { color: 'default', label: 'Approved', bgColor: '#F9A825' },
    'On Hold': { color: 'default', label: 'Approved', bgColor: '#F9A825' },

    completed: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
    resolved: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
    Completed: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
  };

  const viewInvoice = (row: any) => {
    navigate(`/invoices/${row.id}`);
  };

  const invoiceColumns: GridColDef[] = [
    {
      headerName: 'ID',
      headerClassName: 'CommonHeaderClass',
      field: 'invoiceShowId',
      minWidth: 150,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents" onClick={() => viewInvoice(params.row)}>
          {params.value}
        </CellSpan>
      ),
    },
    {
      headerName: 'Worker',
      headerClassName: 'CommonHeaderClass',
      field: 'employeeName',
      minWidth: 150,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Start Date',
      headerClassName: 'CommonHeaderClass',
      field: 'periodStart',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'End Date',
      headerClassName: 'CommonHeaderClass',
      field: 'periodEnd',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Company',
      headerClassName: 'CommonHeaderClass',
      field: 'companyName',
      minWidth: 150,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Client',
      headerClassName: 'CommonHeaderClass',
      field: 'clientName',
      minWidth: 140,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Job Title',
      headerClassName: 'CommonHeaderClass',
      field: 'jobTitle',
      minWidth: 110,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Hire type',
      headerClassName: 'CommonHeaderClass',
      field: 'hireType',
      minWidth: 90,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Total Unit',
      headerClassName: 'CommonHeaderClass',
      field: 'totalUnits',
      minWidth: 90,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Version',
      headerClassName: 'CommonHeaderClass',
      field: 'version',
      minWidth: 90,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Status',
      field: 'status',
      width: 140,
      renderCell: params => {
        const status = params.value as string;
        const { label, bgColor } = statusMapping[status] || {
          color: 'default',
          label: 'Unknown',
          bgColor: '#9e9e9e',
        };
        return (
          <Chip
            label={label}
            variant="outlined"
            style={{
              backgroundColor: bgColor,
              fontSize: '12px',
              color: 'white',
              borderColor: 'transparent',
              textTransform: 'capitalize',
              borderRadius: '6px',
            }}
          />
        );
      },
    },
  ];

  const formik = useFormik({
    initialValues: {
      moduleCategory: '',
      subCatergory: '',
      subject: '',
      description: '',
      priority: '',
      attachments: '',
      searchQuery: '',
      invocieCategory: '',
    },
    validationSchema,
    onSubmit: async (values: any) => {
      try {
        console.log('Form Submitted:', values);
      } catch (error) {
        console.error('Error during form submission', error);
      }
    },
  });

  const billInvoice = () => {
    // navigate('/invoices/create');
    console.log('we have to bill process api hit');
  };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [searchTerm, setsearchTerm] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [status, setStatus] = useState('');
  const [newFilterIsOpen, useNewFilterModalIsOpen] = useState<boolean>(false);
  const companyId = '';

  const startDate = DateTime.now().minus({ days: 14 }).toJSDate();
  const [startDateFilter, setStartDate] = useState<Date>(startDate);
  const [statusKey, setStatusKey] = useState<number>(0);

  const [endDateFilter, setEndDateFilter] = useState<Date>();
  const [companyIdFilter, setCompanyIdFilter] = useState<string>('');
  // const [status, setStatus] = useState<string>('');
  const [employmentType, setEmploymentType] = useState<string>('');
  const [showInvocieId, setshowInvocieId] = useState<string>('');
  const [employmentStatus, setEmploymentStatus] = useState<string>('');

  const [downloadOpen, setDownloadOpen] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const [isProcessBillingOpen, setIsProcessBillingOpen] = useState(false);

  const [filters, setFilters] = useState({
    startDate: null as Date | null,
    endDate: null as Date | null,
    status: '',
    hireType: '',
    showInvocieId: '',
    // clientName: '',
    clientName: [] as string[],
    employeeName: '',
    companyName: '',
    dateCriteria: '',
    dateFilterType: '',
    assignmentId: '',
    accountingId: '',
  });

  const getApiDateParams = () => {
    const start = filters.startDate ? formatDateForApi(filters.startDate) : null;
    const end = filters.endDate ? formatDateForApi(filters.endDate) : null;

    switch (filters.dateFilterType) {
      case 'after':
        return { startDate: start, endDate: null };
      case 'before':
        return { startDate: start || end, endDate: null };
      case 'between':
        return { startDate: start, endDate: end };
      case 'exactly':
        return { startDate: start, endDate: start };
      default:
        return { startDate: null, endDate: null };
    }
  };
  const { startDate: apiStartDate, endDate: apiEndDate } = getApiDateParams();

  const {
    isLoading,
    isFetching,
    data: invoiceData,
    refetch,
  } = useQuery(
    ['invoice-list', page, limit, searchTerm, sortBy, sortDirection, filters],
    async () => {
      const result = await InvoiceService.getInvoiceBillList({
        page,
        limit,
        search: searchTerm,
        sortBy,
        sortDirection,
        status: filters.status,
        hireType: filters.hireType,
        showInvocieId: filters.showInvocieId,
        assignmentId: filters.assignmentId,
        accountingId: filters.accountingId,
        clientName: filters.clientName,
        employeeName: filters.employeeName,
        dateCriteria: filters.dateCriteria,
        dateFilterType: filters.dateFilterType,

        startDate: apiStartDate,
        endDate: apiEndDate,
        ...(filters.companyName ? { companyName: filters.companyName } : {}),
      });

      console.log('Invoice API Result:', result);

      return result;
    },
    {
      keepPreviousData: true,
    }
  );

  // useEffect(() => {
  //   isInvocieFetching();
  // }, [page, limit, searchTerm, status, isInvocieFetching]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePerRowsChange = async (newLimit: number, newPage: number) => {
    setLimit(newLimit);
    setPage(newPage);
  };

  const onPageMetaChange = (model: any) => {
    setPage(model.page + 1);
    setLimit(model.pageSize);
  };

  const onSortMetaChange = async (changes: any) => {
    setSortBy(changes[0].field as unknown as string);
    setSortDirection(changes[0].sort);
  };

  const updateFilters = (
    startDate: Date | null,
    endDate: Date | null,
    selectedCompany: any,
    status: string,
    employmentType: string,
    showInvocieId: string,
    assignmentId: string,
    accountingId: string,
    employmentStatus: string,
    // clientName: string,
    clientName: string[],
    hireType: string,
    employeeName: string,
    dateCriteria: string,
    dateRangeType: string
  ) => {
    setPage(1);

    setFilters({
      startDate,
      endDate,
      status,
      hireType,
      showInvocieId,
      assignmentId,
      accountingId,
      clientName,
      employeeName,
      companyName: selectedCompany || '',
      dateCriteria: dateCriteria || 'period',
      dateFilterType: dateRangeType,
    });
  };

  const resetFilters = () => {
    setFilters({
      startDate: null,
      endDate: null,
      status: '',
      hireType: '',
      showInvocieId: '',
      clientName: [],
      employeeName: '',
      companyName: '',
      dateCriteria: '',
      dateFilterType: '',
      assignmentId: '',
      accountingId: '',
    });

    setPage(1);
  };

  const handleDownload = async (type: 'excel' | 'csv' | 'pdf') => {
    setDownloadLoading(true);
    try {
      const url = InvoiceService.downloadInvoicesBill({
        type,
        search: searchTerm,
        sortBy,
        sortDirection,
        status: filters.status,
        hireType: filters.hireType,
        showInvocieId: filters.showInvocieId,
        assignmentId: filters.assignmentId,
        accountingId: filters.accountingId,
        clientName: filters.clientName,
        employeeName: filters.employeeName,
        dateCriteria: filters.dateCriteria,
        dateFilterType: filters.dateFilterType,
        // startDate: apiStartDate,
        // endDate: apiEndDate,
        startDate: apiStartDate || undefined,
        endDate: apiEndDate || undefined,
        ...(filters.companyName ? { companyName: filters.companyName } : {}),
      });

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken') || ''}`,
        },
      });

      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();

      // Create a file name
      const fileExtension = type === 'pdf' ? 'zip' : type === 'csv' ? 'csv' : 'xlsx';
      const fileName = `Invoices_Bill_${new Date().toISOString().split('T')[0]}.${fileExtension}`;

      // Create a temporary link to trigger download
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);

      setDownloadOpen(false);
    } catch (error) {
      console.error('Error downloading invoices:', error);
    } finally {
      setDownloadLoading(false);
    }
  };

  const formattedData = invoiceData?.items?.map(row => ({
    ...row,
  }));

  return (
    <Container>
      <NewFiltersInvoice
        isOpen={newFilterIsOpen}
        setIsOpen={useNewFilterModalIsOpen}
        updateFilters={updateFilters}
        statusOptions={billProcessStatusOptions}
      />

      <ProcessBillingModal
        isOpen={isProcessBillingOpen}
        setIsOpen={setIsProcessBillingOpen}
        totalInvoices={invoiceData?.meta?.total || 0}
        filters={filters}
        onSuccess={resetFilters}
      />

      <DownloadInvoiceModal
        isOpen={downloadOpen}
        setIsOpen={setDownloadOpen}
        onDownload={handleDownload}
        loading={downloadLoading}
      />

      <ScreenHeader>
        <PageTitle>Bill Invoices</PageTitle>

        <RightHeader style={{ display: 'flex', alignItems: 'center' }}>
          <RegularButton onClick={() => setIsProcessBillingOpen(true)}>Process Billing</RegularButton>

          <RegularButton
            onClick={() => {
              useNewFilterModalIsOpen(!newFilterIsOpen);
            }}
          >
            {t('employeeReviewChanges.newFilters')}
          </RegularButton>
          <RegularButton onClick={() => setDownloadOpen(true)}>Download Invoice</RegularButton>
          {/* <a href={InvoiceService.downloadInvoices()} target="_blank" rel="noopener noreferrer">
            <RegularButton>{t('global.form.downloadInvocie')}</RegularButton>
          </a> */}
        </RightHeader>
      </ScreenHeader>
      {isLoading || isFetching ? (
        <EmptyContainer>
          <Loader />
        </EmptyContainer>
      ) : (
        <div>
          {formattedData && formattedData.length > 0 ? (
            <DataGrid
              rows={formattedData}
              columns={invoiceColumns}
              pagination
              paginationMode="server"
              onPaginationModelChange={state => {
                onPageMetaChange(state);
              }}
              onSortModelChange={state => {
                onSortMetaChange(state);
              }}
              paginationModel={{
                page: page - 1,
                pageSize: limit,
              }}
              pageSizeOptions={[10, 20, 50, 100]}
              rowCount={invoiceData?.meta?.total || 0}
              loading={isLoading || isFetching}
              disableColumnFilter
              sx={{
                font: '14px Biotif',
                fontWeight: 'bold',
                '& .CommonHeaderClass': {
                  color: '#9399B2',
                  font: '16px Biotif',
                  fontWeight: 'bold',
                },
                minHeight: '150px',
                '& .MuiDataGrid-scrollbar--horizontal': {
                  zIndex: 0,
                },
              }}
            />
          ) : (
            <div style={{ minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              &quot;No Invoices to display.&quot;
            </div>
          )}
        </div>
      )}
    </Container>
  );
};

export default InvoiceListBillProcess;
